import { searchApiClient } from '@/datasources/search.datasource';
import {
  SearchApiProcedureResult,
  SearchApiTermResponse,
} from '@/app/(main)/_components/search-modal/_services/search-api/search-api.type';

export interface FindProceduresByTermParams {
  term: string;
  citySlug?: string;
  categories?: string[];
  page?: number;
  limit?: number;
}

export interface FindProceduresByTermResult {
  procedures: SearchApiProcedureResult[];
  hasMore: boolean;
}

export async function findProceduresByTerm({
  term,
  citySlug,
  categories,
  page,
  limit,
}: FindProceduresByTermParams): Promise<FindProceduresByTermResult> {
  const response = await searchApiClient.get<SearchApiTermResponse<SearchApiProcedureResult>>(
    '/procedures/find-by-term',
    {
      term,
      city: citySlug,
      categories,
      page,
      limit,
    },
  );

  return {
    procedures: response.data.data ?? [],
    hasMore: response.data.hasMore ?? false,
  };
}
